import BenchlingConfig from 'BenchlingConfig';

/**
 * Return whether a user is allowed to create a new analysis.
 */
export default function isCreateAnalysisEnabled(): boolean {
  return BenchlingConfig.ENABLE_ANALYSIS_TOOL_WITHOUT_INSIGHTS;
}
